var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "box-card",
      style: {
        marginTop: _vm.$store.state.chat.isMobileMode ? "80px" : "unset"
      }
    },
    [
      _c(
        "span",
        {
          staticClass: "close-ui-profile",
          on: {
            click: function($event) {
              return _vm.$store.dispatch(
                "contact/setActiveContactCustumer",
                null
              )
            }
          }
        },
        [_c("i", { staticClass: "fas fa-times" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ui-profile" },
        [
          _c("div", { staticClass: "avatar" }, [
            _vm.customerContact.custImage
              ? _c("img", {
                  attrs: {
                    src:
                      "https://cdnx.softsq.com/thumb/unsafe/84x84/" +
                      encodeURIComponent(
                        encodeURIComponent(_vm.customerContact.custImage)
                      )
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "text-nameline",
            domProps: { textContent: _vm._s(_vm.customerContact.custName) }
          }),
          _vm._v(" "),
          _c("strong", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isShowEditText,
                expression: "!isShowEditText"
              }
            ],
            staticClass: "center",
            domProps: {
              textContent: _vm._s(
                _vm.customerContact.custNameNew == ""
                  ? _vm.customerContact.custName
                  : _vm.customerContact.custNameNew
              )
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowEditText,
                expression: "isShowEditText"
              }
            ],
            ref: "custName",
            attrs: {
              placeholder: "Please input",
              value:
                _vm.custNameProfile == null
                  ? _vm.customerContact.custNameNew == ""
                    ? _vm.customerContact.custName
                    : _vm.customerContact.custNameNew
                  : _vm.custNameProfile
            },
            on: { input: _vm.enterContact }
          }),
          _vm._v(" "),
          _c("el-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isShowEditText,
                expression: "!isShowEditText"
              }
            ],
            attrs: {
              type: "primary",
              size: "medium",
              icon: "el-icon-edit",
              circle: ""
            },
            on: {
              click: function($event) {
                return _vm.$store.dispatch("contact/setIsShowEdit", true)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowEditText,
                  expression: "isShowEditText"
                }
              ],
              staticClass: "bottom clearfix"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "info", size: "medium", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.$store.dispatch("contact/setIsShowEdit", false)
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success", size: "medium", round: "" },
                  on: { click: _vm.fnSaveContact }
                },
                [_vm._v("Save")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "center box-add-tag" },
            [
              _vm._l(_vm.dynamicTags, function(tag) {
                return _c(
                  "el-tag",
                  {
                    key: tag,
                    attrs: { closable: "", "disable-transitions": false },
                    on: {
                      close: function($event) {
                        return _vm.handleClose(tag)
                      }
                    }
                  },
                  [_vm._v(_vm._s(tag))]
                )
              }),
              _vm._v(" "),
              _vm.inputVisible
                ? _c("el-input", {
                    ref: "saveTagInput",
                    staticClass: "input-new-tag",
                    attrs: { size: "mini" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleInputConfirm($event)
                      },
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        return _vm.handleInputConfirm($event)
                      }
                    },
                    model: {
                      value: _vm.inputValue,
                      callback: function($$v) {
                        _vm.inputValue = $$v
                      },
                      expression: "inputValue"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "component-fade", mode: "out-in" } },
                [
                  _vm.isShowSuccess
                    ? _c("h4", { staticClass: "uk-text-success" }, [
                        _c("span", {
                          staticClass: "uk-margin-small-right",
                          attrs: { "uk-icon": "check" }
                        }),
                        _vm._v("\n          บันทึกสำเร็จ\n        ")
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "component-fade", mode: "out-in" } },
                [
                  _vm.isShowError
                    ? _c("h4", { staticClass: "uk-text-danger" }, [
                        _c("span", {
                          staticClass: "uk-margin-small-right",
                          attrs: { "uk-icon": "close" }
                        }),
                        _vm._v(
                          "\n          " + _vm._s(_vm.isShowMsg) + "\n        "
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "uk-margin-top uk-card uk-card-default uk-card-body box-tag",
                  class: { scroll: _vm.tagAlls.length > 20 }
                },
                [
                  _c("h3", { staticClass: "uk-card-title" }, [
                    _vm._v("All Tags")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.tagAlls, function(tag) {
                    return _c(
                      "span",
                      {
                        key: tag,
                        staticClass: "tagAll",
                        on: {
                          click: function($event) {
                            return _vm.addTagsCusFromAlltags(tag)
                          }
                        }
                      },
                      [
                        _c("el-tag", { attrs: { size: "medium" } }, [
                          _vm._v(_vm._s(tag))
                        ])
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bottom clearfix footer-box-tag" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "info", size: "medium", round: "" },
                  on: { click: _vm.cancelTagofCustomer }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    size: "medium",
                    round: "",
                    disabled:
                      _vm.dynamicTags.length == 0 &&
                      !_vm.inputValue && _vm.inputVisible
                        ? true
                        : false
                  },
                  on: { click: _vm.saveTagOfCustomer }
                },
                [_vm._v("Save")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "info", size: "medium", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.gotochat(_vm.customerContact)
                    }
                  }
                },
                [_vm._v("Chat")]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00d7d077", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d7d077","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileInfo.vue
// module id = null
// module chunks = 